import React from 'react'
import IndoNepalMoney from './indoNepalMoneyFill/IndoNepalMoney'
import IndoNepalMoneyList from './indoNepalMoneyList/IndoNepalMoneyList'
import Breadcrumbs from '../../../common/breadcrumb/Breadcrumbs'

function IndoNepalMoneyTrans() {
  return (
    <>
    <Breadcrumbs breadCrumbsTitle={""}/>
    <IndoNepalMoney/>
    <IndoNepalMoneyList/>
    </>
  )
}

export default IndoNepalMoneyTrans